import { Controller, Menu, Toolbar } from '@tencent/workbench';
import { MutiPictureSizeFeature } from './muti-picture-size-feature';
import { INSERT_TEXT_MENU_CONFIGS, TOOLBAR_ITEMS, config } from './config';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { wrapIdForVip } from '@src/framework/workbench/util/wrap-id-util';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
    toolbarItems: TOOLBAR_ITEMS,
})
export class MutiPictureSizeController {
    public constructor(private readonly feature: MutiPictureSizeFeature) {
    }

    @Menu(config.id, 'onClick')
    @Toolbar(wrapIdForVip(config.id), 'onClick')
    public onClick() {
        this.feature.getAppService()
            .editableServiceLayer?.quickToolDialogManager.promise().then((quickToolDialogManager) => {
                quickToolDialogManager.showDialog(ActionType.MUTI_PICTURE_SIZE_SETTING);
            });
    }

    @Toolbar(wrapIdForVip(config.id), 'shouldDisabled')
    public shouldDisabled() {
        return this.feature.shouldDisabled(config.id);
    }
}
